import styled from "@emotion/styled";
import { BorderRadius, Colors, ShadowValue, Spacing } from "@snapchat/snap-design-system";
// eslint-disable-next-line no-restricted-imports -- SDS needs to export Durations from their root barrel
import { Durations } from "@snapchat/snap-design-system/es/constants";

import { appearingAnimation } from "../../shared/styles";

export const Card = styled.div`
    padding: ${Spacing.MD}px ${Spacing.LG}px;

    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
    box-shadow: ${ShadowValue.regular};

    animation: ${appearingAnimation} ${Durations.STANDARD} ease;
`;

export const CardTitle = styled.span`
    padding: 8px 0;

    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: ${Colors.Black.V200};
`;
